module.exports = __webpack_public_path__ + "images/pro/pro-black@2x-b8ac89d4cbb11f710ccd0bf404179d98.png";